import { Injectable } from "@angular/core";
import { AppSettings } from "../shared/AppSettings";
import { HttpClient } from "@angular/common/http";
import { ItemModel } from "../model/itemModel";
import { equipmentReceiver } from "../model/equipmentReceiver";

@Injectable()
export class ItemService {
  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) {}

  addItem = (item: ItemModel) => {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/AddItem`,
      item
    );
  };

  getAllItems = () => {
    return this.httpClient.get<ItemModel[]>(
      `${this.rootUrl}/api/ItemController/GetAllItems`
    );
  };

  getItemByOrderNumber = (order: string) => {
    return this.httpClient.get<ItemModel[]>(
      `${this.rootUrl}/api/ItemController/GetItemByOrderNumber/${order}`
    );
  };

  updateItem = (item: ItemModel) => {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/UpdateItem`,
      item
    );
  };

  getItemList = () => {
    return this.httpClient.get<string[]>(
      `${this.rootUrl}/api/ItemController/GetItemList`
    );
  };

  deleteItem = (itemId: number) => {
    return this.httpClient.get<boolean>(
      `${this.rootUrl}/api/ItemController/DeleteItem/${itemId}`
    );
  };

  signEquipmentRequest = (request: equipmentReceiver) => {
    return this.httpClient.post<boolean>(
      `${this.rootUrl}/api/ItemController/ReceiverSignEquipment`,
      request
    );
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/item.service.ts